import {
  SET_TIME
} from "./actionTypes";

export const setTime = time => async (dispatch) => {
  dispatch({ type: SET_TIME, payload: time });
};